import { configureStore } from '@reduxjs/toolkit';
import RootReducer from './RootReducer';

export const RootStore = configureStore({
  reducer: RootReducer
});

export type AppDispatch = typeof RootStore.dispatch;
export default RootStore;
